import sanitizeHtml from 'sanitize-html'

interface ISanitizeSettings {
  defaultTagWhitelist?: Array<string>,
  nonTextTagBlacklist?: Array<string>,
  allowedClassesObject?: any,
  allowedAttributesObject?: any,
}

export const createAndSanitizeMarkup = (dirtyPayload?: string, sanitizeSettings?: ISanitizeSettings) => {
  if (!dirtyPayload) {
    return { __html: '<div>No Message Found</div>' }
  }

  const defaultTagWhitelist = ['div', 'p', 'li', 'ol', 'ul', 'a', 'br', 'b', 'i', 'em', 'strong']
  const nonTextTagBlacklist = ['style', 'script', 'textarea', 'option', 'img']
  const allowedClassesObject = {
    a: ['ch-c-button', 'ds-c-button', 'ch-c-render-html__btn-cta', 'ch-c-button--primary', 'ds-c-button--solid'],
    div: ['ch-c-render-html__flex-2']
  }
  const allowedAttributesObject = {
    a: ['href']
  }

  const cleanPayload = sanitizeHtml(dirtyPayload, {
    allowedTags: sanitizeSettings?.defaultTagWhitelist ?? defaultTagWhitelist,
    allowedAttributes: sanitizeSettings?.allowedAttributesObject ?? allowedAttributesObject,
    allowedClasses: sanitizeSettings?.allowedClassesObject ?? allowedClassesObject,
    nonTextTags: sanitizeSettings?.nonTextTagBlacklist ?? nonTextTagBlacklist,
    disallowedTagsMode: 'discard'
  })

  return { __html: cleanPayload }
}
